import Footer from "../../components/molecules/footer";
import Header from "../../components/molecules/header";
import ImageGallery from "../../components/molecules/imageGallery";

const Gallery = () => {
  return (
    <>
      <Header />
      <main>
        <ImageGallery />
      </main>
      <Footer />
    </>
  );
};

export default Gallery;
